import { DirectoryListItemComponent } from '@accredible-frontend-v2/new-components/ui-directory-of-directories';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Directory } from '@directory-of-directories/domain';

@Component({
  standalone: true,
  selector: 'dod-directory-list',
  templateUrl: `./directory-list.component.html`,
  styleUrls: ['./directory-list.component.scss'],
  imports: [DirectoryListItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryListComponent {
  directories = input<Directory[]>([]);
  isLoading = input(false);
}
